module.exports = "pegasus/assets/custom-3-google.png";